import { Injectable, Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IGenderApiService } from './gender-api.interface';
import { ILogger } from '../logger';

@Injectable()
export class GenderApiService implements IGenderApiService {
  data: string[];

  constructor(@Inject('LoggerInjected') private logger: ILogger) {
    this.data = ['Female', 'Male'];
  }

  list(): Observable<string[]> {
    this.logger.debug('GenderApiService.List', this.data);
    return of(this.data);
  }
}
